import React, { forwardRef, memo } from 'react'

const CoinPrimaryIcon = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    ref={ref}
    width="29.4"
    height="29.4"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 42 42"
    fill="none"
    stroke="#78BE20"
    strokeWidth={3.227}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="M16.174 19.949c7.044 0 12.755-2.57 12.755-5.74s-5.711-5.74-12.755-5.74S3.419 11.039 3.419 14.209s5.711 5.74 12.755 5.74Z" />
    <path d="M3.419 14.209v6.378c0 3.169 5.711 5.739 12.755 5.739s12.755-2.57 12.755-5.739v-6.378" />
    <path d="M11.072 19.471v6.377" />
    <path d="M28.929 16.237c5.823.533 10.204 2.848 10.204 5.625 0 3.17-5.711 5.74-12.755 5.74-3.125 0-5.988-.505-8.206-1.345" />
    <path d="M13.623 26.212V28.24c0 3.17 5.711 5.74 12.755 5.74s12.755-2.57 12.755-5.74v-6.378" />
    <path d="M31.48 27.124v6.378" />
    <path d="M21.276 19.471v14.03" />
  </svg>
))

CoinPrimaryIcon.displayName = 'CoinPrimaryIcon'
export default memo(CoinPrimaryIcon)
